import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';

export const ActionLinks = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px 20px',
  marginBottom: 28,
  paddingBottom: 20,
  borderBottom: `1px solid ${getDrugTestThemeTokens(theme).borderSoft}`,
}));

export const ActionLink = styled('button')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    padding: 0,
    border: 'none',
    background: 'none',
    fontFamily: 'inherit',
    fontSize: 13,
    fontWeight: 500,
    color: t.actionLink,
    cursor: 'pointer',
    lineHeight: 1.4,
    '&:hover:not(:disabled)': {
      textDecoration: 'underline',
      color: t.actionLinkHover,
    },
    '&:disabled': {
      color: t.textMuted,
      opacity: 0.45,
      cursor: 'not-allowed',
    },
  };
});
